'use client';

import { siteConfig } from '@/config/site.config';
import hideRechartsConsoleError from '@/utils/recharts-console-error';
import { ThemeProvider as NextThemeProvider } from 'next-themes';

hideRechartsConsoleError();

export function ThemeProvider({
  children,
}: React.PropsWithChildren<object>) {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme={siteConfig.mode || 'system'}
      enableSystem
      storageKey="theme"
      disableTransitionOnChange
      value={{
        light: 'light',
        dark: 'dark',
      }}
    >
      {children}
    </NextThemeProvider>
  );
}